
import React from 'react';

const LoadingState: React.FC = () => {
  return (
    <div className="flex flex-1 items-center justify-center p-10">
      <div className="text-center">
        <div className="h-8 w-8 border-2 border-t-blue-500 border-blue-200 rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-500">Chargement des vidéos...</p>
      </div>
    </div>
  );
};

export default LoadingState;
